import { isValid } from "date-fns";

export const isDateValid = (date?: Date | null): date is Date => {
  if (!(date instanceof Date)) return false;
  return isValid(date) && date.getFullYear() > 1900;
};

export const isStringDateValid = (value?: string | null): value is string => {
  if (typeof value !== "string") return false;

  const date = new Date(value);
  return isValid(date) && new Date(date).getFullYear() >= 1900;
};
